module.exports = __webpack_public_path__ + "img/pro_09.5282b705.jpg";